module.exports = __webpack_public_path__ + "img/flying-world.4504a1b6.svg";